import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateTroupeStats = (state: StatsSnapshot) => {
  const troupe = state.generators.troupe;

  const generatedBards = troupe.owned * troupe.baseGeneration;

  stats.troupe = {
    unitsGeneration: generatedBards,
  };
};
